import { ref } from "s2-engine";

import type { ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, {
  isRootModel,
  Optional,
  Silent,
} from "@/__main__/data-model.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";

export const model = {
  averageDeathsAt_10Min: Number,
  averageFirstWardTime: Number,
  averageGankDeaths: Number,
  averageLaningPhaseDeaths: Number,
  averageLaningPhaseSoloKills: Number,
  averageWardsPlaced: Number,
  championCounts: [
    {
      count: Number,
      id: String,
    },
  ],
  firstGankedLaneCounts: [
    {
      count: Number,
      id: String,
    },
  ],
  largestCritical: Number,
  largestKillingSpree: Number,
  largestMultiKill: Number,
  lastFewWins: [Boolean],
  lastGame: Silent(String),
  recentlyPlayedWith: [
    {
      gameName: String,
      games: Number,
      leagueProfileId: Number,
      profileIconId: Number,
      summonerName: Optional(String),
      tagLine: String,
      wins: Number,
    },
  ],
  roles: [
    {
      count: Number,
      name: String,
    },
  ],
  teammateCounts: [
    {
      count: Number,
      id: String,
    },
  ],
  totalGames: Number,
  updatedAt: String,
  [isRootModel]: true,
} satisfies ModelDefinition;

const afterTransformModel = {
  averageDeathsAt_10Min: Number,
  averageFirstWardTime: Number,
  averageGankDeaths: Number,
  averageLaningPhaseDeaths: Number,
  averageLaningPhaseSoloKills: Number,
  averageWardsPlaced: Number,
  championCounts: [
    {
      count: Number,
      id: Number,
    },
  ],
  firstGankedLaneCounts: [
    {
      count: Number,
      id: RoleSymbol,
    },
  ],
  largestCritical: Number,
  largestKillingSpree: Number,
  largestMultiKill: Number,
  lastFewWins: [Boolean],
  lastGame: Silent(String),
  recentlyPlayedWith: [
    {
      gameName: String,
      games: Number,
      leagueProfileId: Number,
      profileIconId: Number,
      summonerName: Optional(String),
      tagLine: String,
      wins: Number,
    },
  ],
  roles: [
    {
      count: Number,
      name: RoleSymbol,
    },
  ],
  teammateCounts: [
    {
      count: Number,
      id: String,
    },
  ],
  totalGames: Number,
  updatedAt: String,
} satisfies ModelDefinition;

const afterTransformValidation = createModel(afterTransformModel);

const apiModelValidation = createModel({
  data: { playstyles: model },
});

function typeCorrectData(data) {
  const championCounts = data.championCounts.map((championCount) => {
    return {
      ...championCount,
      id: Number.parseInt(championCount.id, 10),
    };
  });

  return {
    ...data,
    championCounts,
  };
}

function transform(data) {
  data = apiModelValidation(data);

  const typeCorrectedData = typeCorrectData(data.data.playstyles);
  const result = afterTransformValidation(typeCorrectedData);
  return ref(result); // ref needed for drafting
}

export default transform;
